import { h, Host } from "@stencil/core";
import { limitSlotElements } from "../../../utils/limitSlotElements";
export class TableBodyNeo {
    constructor() {
        this.sticky = undefined;
    }
    host;
    componentDidLoad() {
        limitSlotElements(this.host, {
            allowed: {
                default: ["ux-table-row-neo"]
            }
        });
    }
    /**
     *
     */
    cellCountChange;
    handleSlotChange(e) {
        if (!e) {
            return;
        }
        const nodes = e.assignedNodes().filter((item) => item.nodeName.toLowerCase() !== "#text");
        this.cellCountChange.emit(nodes.length);
    }
    render() {
        return (h(Host, { key: 'c2c4ce65d5fb6e2a275de4e960ceeae90870d2ad' }, h("slot", { key: 'ef1685af001207ab3e89ec64b6e3329391689419', onSlotchange: (e) => this.handleSlotChange(e.target) })));
    }
    static get is() { return "ux-table-header-neo"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["table-header-neo.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["table-header-neo.css"]
        };
    }
    static get properties() {
        return {
            "sticky": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If true, the header will stick to the top of the table when scrolling."
                },
                "attribute": "sticky",
                "reflect": true
            }
        };
    }
    static get events() {
        return [{
                "method": "cellCountChange",
                "name": "cellCountChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "host"; }
}
//# sourceMappingURL=table-header-neo.js.map
